<template>
  <div class="falcon-chart" :class="locked? 'locked': ''" ref="chart">

  </div>
</template>

<script>
import Chart from 'chart.js';
import {CHART_COLORS, FONT_FAMILY} from "./chartColors";
import {formatDollars, formatDollarsNoZeros, formatMillionsDollars} from "../../moneyUtils";
import echarts from "echarts";
import {xAxisStyle} from "@/shared/components/charts/charts-utils";

export default {
  name: 'scorecardGraph',
  data() {
    console.log(this, 'this')
    return {
      graphData: this.data
    }
  },
  props: ['data', 'locked', 'print'],
  mounted() {

    var myChart = echarts.init(this.$refs['chart'], null, {
      // renderer: 'svg'
    });
    let bold = {
      rich: {
        bold: {
          fontWeight: 'bold',
        },
      }
    };

    // specify chart configuration item and data
    var option = {
      tooltip: {
        show: true,
        trigger: 'axis'
      },
      textStyle: {
        fontFamily: FONT_FAMILY
      },
      legend: {
        show: true,
        orient: 'vertical',
        right: 0,
        data: [{
          name: 'Your Valuation',
          icon: 'circle'
        },{
          name: 'Average valuation for similar startups',
          icon: 'circle'
        }]
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 1,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      },
      xAxis: {
        axisLine: {
          lineStyle: {
            color: '#899094'
          },
        },
        axisTick: {
          show: false,
        },
        nameRotate: -30,
        axisLabel: {
          fontSize: this.print? 11: 12,
          // rotate:  45
        },
        tickOptions: {showGridLine: false},
        type: 'category',
        data: [xAxisStyle(`${formatDollarsNoZeros(this.graphData.team_strength)}` + '\nTeam\nStrength'),
          xAxisStyle(`${formatDollarsNoZeros(this.graphData.opportunity_size)}`  + '\nOpportunity\nSize'),
          xAxisStyle(`${formatDollarsNoZeros(this.graphData.product_technology)}`  + '\nProduct\n&Technology'),
          xAxisStyle(`${formatDollarsNoZeros(this.graphData.competitive_environment)}`  + '\nCompetitive\nEnvironment'),
          xAxisStyle(`${formatDollarsNoZeros(this.graphData.marketing_sales)}`  + '\nMarketing\n&Sales'),
         xAxisStyle(`${formatDollarsNoZeros(this.graphData.additional_investment)}`  + '\nAdditional\nInvestment')
        ]
      },
      yAxis: {
        axisLabel: {
          show: false,
          color: '#899094',
          formatter: formatMillionsDollars
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: '#fff'

          },
        },
        splitLine: {
          lineStyle: {
            color: ['#E3E9EA'],
          }
        },
      },
      series: [

        {
          type: 'bar',
          name: 'Your Valuation',
          data: [
            this.graphData.team_strength,
            this.graphData.opportunity_size,
            this.graphData.product_technology,
            this.graphData.competitive_environment,
            this.graphData.marketing_sales,
            this.graphData.additional_investment,
          ],
          itemStyle: {
            color: '#FC4F26',
            barBorderRadius: [5, 5, 0, 0]
          },
        },
        {
          type: 'bar',
          name: 'Average valuation for similar startups',
          data: [
            this.graphData.team_strength_max,
            this.graphData.opportunity_size_max,
            this.graphData.product_technology_max,
            this.graphData.competitive_environment_max,
            this.graphData.marketing_sales_max,
            this.graphData.additional_investment_max,
          ],
          itemStyle: {
            color: '#E3E9EA',
            barBorderRadius: [5, 5, 0, 0]
          },
        }
      ]
    };

    myChart.setOption(option);

  },
  methods: {},
  computed: {},
}
</script>

<style scoped>
.falcon-chart {
  width: 100%;
  height: 400px;
}
</style>

